import { useEffect, useState } from 'react';
import moment, { Duration } from 'moment-timezone';

const useTimeDifference = (timestamp?: string): Duration | null => {
  const [timeDifference, setTimeDifference] = useState<Duration | null>(null);

  useEffect(() => {
    if (!timestamp) return;

    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const calculateTimeDifference = () => {
      const now = moment();
      const targetDate = moment.tz(timestamp, userTimezone);
      const diff = targetDate.diff(now);
      const duration = moment.duration(diff);
      setTimeDifference(duration);
    };

    calculateTimeDifference();

    const interval = setInterval(calculateTimeDifference, 1000);

    return () => clearInterval(interval);
  }, [timestamp]);

  return timeDifference;
};

export default useTimeDifference;
